import { render, staticRenderFns } from "./qaHistory.vue?vue&type=template&id=3966b375&scoped=true&"
import script from "./qaHistory.vue?vue&type=script&lang=js&"
export * from "./qaHistory.vue?vue&type=script&lang=js&"
import style0 from "./qaHistory.vue?vue&type=style&index=0&id=3966b375&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3966b375",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3966b375')) {
      api.createRecord('3966b375', component.options)
    } else {
      api.reload('3966b375', component.options)
    }
    module.hot.accept("./qaHistory.vue?vue&type=template&id=3966b375&scoped=true&", function () {
      api.rerender('3966b375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/xiazeng/qaHistory.vue"
export default component.exports